/* eslint-disable */
	export interface B2BResetPasswordTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface KeyValuePair<TKey, TValue> {
		key: TKey;
		value: TValue;
	}
	export interface B2BRequestAccessTileModel {
		companyTypes: KeyValuePair<string, string>[];
		confirmationText: HtmlString;
		countries: CountryModel[];
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BSimpleRequestAccessTileModel {
		companyTypes: KeyValuePair<string, string>[];
		confirmationText: HtmlString;
		countries: CountryModel[];
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface CountryModel {
		code: string;
		name: string;
	}
	export interface XhtmlString {
		fragmentParser: IFragmentParser;
		fragments: IStringFragment[];
		isEmpty: boolean;
		isModified: boolean;
		isReadOnly: boolean;
		parserMode: FragmentParserMode;
	}
	export enum FragmentParserMode {
		LeaveMappedLinks = 0,
		RemapLinks = 1
	}
	export interface IFragmentParser {
	}
	export interface IStringFragment {
		internalFormat: string;
	}
	export interface B2BReceiptHeroTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BProfileTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		editProfileInformationDescription: HtmlString;
		tileId: number;
	}
	export interface B2BProfileUserListTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BExchangeRateTileModel {
		description: HtmlString;
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BProductDetailTileModel extends BaseProductDetailTileModel {
		co2EmissionsLogo: MediaModel;
		designYourSelfLink: LinkModel;
	}
	export interface BaseProductDetailTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		freightInfo: FreightInfoModel;
		moduleConfigurator: ModuleConfiguratorTileModel;
		powerStep: PowerStepModel;
		productDetail: any;
		tileId: number;
		tiles: TileModel[];
	}
	export interface FreightInfoModel {
		content: HtmlString;
		title: string;
	}
	export interface ModuleConfigurationModuleModel {
		quantity: number;
		sku: string;
	}
	export interface ModuleConfiguratorTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		isEnabled: boolean;
		modules: ModuleConfigurationModuleModel[];
		tileId: number;
	}
	export interface PowerStepModel {
		header: string;
		isEnabled: boolean;
		text: string;
	}
	export interface ProductAddOnTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface ProductCareProductsTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		linkTitle: string;
		mainContent: HtmlString;
		readMoreLink: LinkModel;
		tileId: number;
	}
	export interface ProductCoverMaterialTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		link: LinkModel;
		linkTitle: string;
		media: MediaModel;
		text: HtmlString;
		tileId: number;
	}
	export interface ProductDesignerTileModel {
		backGroundColorHexCode: string;
		description: string;
		dictionaryLabels: KeyValuePair<string, any>[];
		link: LinkModel;
		media: MediaModel;
		subTitle: string;
		tileId: number;
		title: string;
	}
	export interface ProductDetailRecommendedProductsTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface ProductEnvironmentMediaTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		mirrorLayoutOnFirstSlide: boolean;
		tileId: number;
		tiles: MediaModel[];
	}
	export interface ProductMoreFromSameSeriesTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface ProductSeriesMediaModel {
		media: MediaModel;
		text: string;
	}
	export interface ProductSeriesTileModel {
		bottomDescription: HtmlString;
		dictionaryLabels: KeyValuePair<string, any>[];
		heading: string;
		hexCode: string;
		mediaModel1: ProductSeriesMediaModel;
		mediaModel2: ProductSeriesMediaModel;
		mediaModel3: ProductSeriesMediaModel;
		seriesDescription: string;
		tileId: number;
		uniqueSellingPoints: string[];
	}
	export interface ProductSpecificationTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		readMoreAboutCertificatesLink: LinkModel;
		readMoreAboutClimateFootprintLink: LinkModel;
		readMoreAboutTestsLink: LinkModel;
		tileId: number;
	}
	export interface ProductStoryTellingVideoTileModel {
		media: MediaModel;
		tileId: number;
	}
	export interface ProductTransparencyTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		fillerImage: MediaModel;
		tileId: number;
	}
	export interface ProductUspTileModel {
		hexCode: string;
		tileId: number;
		uspItems: UspTileItem[];
	}
	export interface UspTileItem {
		icon: MediaModel;
		title: string;
	}
	export interface VendorInfoTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		flipVendorDescriptionAndImage: boolean;
		media: TextMediaModel;
		tileId: number;
		vendorId: string;
	}
	export interface ITileDictionaryContentViewModel {
		dictionaryLabels: KeyValuePair<string, any>[];
	}
	export interface TileModel {
		contentType: string;
		model: any;
	}
	export interface CampaignViewModel {
		bottomTitle: string;
		bottomTitleSubtext: string;
		countDownEnabled: boolean;
		countdownLink: LinkViewModel;
		countDownTime: number;
		countdownTopTitle: string;
		countdownTopTitleInBold: boolean;
		endTime?: Date;
		expiredTitle: string;
		isCampaignActive: boolean;
		link: LinkViewModel;
		startTime?: Date;
		title: string;
		topTitle: string;
	}
	export interface FooterColumnModel {
		freeText: string;
		headerLink: LinkViewModel;
		links: LinkViewModel[];
	}
	export interface LinkModel {
		spaLink: boolean;
		url: string;
	}
	export interface LinkViewModel extends LinkModel {
		target: string;
		text: string;
		title: string;
	}
	export interface MediaModel {
		model: any;
		overrideProperties: MediaModelProperties;
		type: string;
	}
	export interface MediaModelProperties {
		autoPlay: boolean;
		focus: boolean;
		zoom: boolean;
	}
	export interface TextMediaModel {
		mediaModel: MediaModel;
		mediaText: string;
	}
	export interface VimeoMediaModel {
		autoPlay: boolean;
		description: string;
		id: string;
		image: ImageFileModel;
		url: Uri;
	}
	export interface VoteModel {
		pollId: string;
		value: string;
	}
	export interface B2BOutletProductDetailTileModel extends BaseProductDetailTileModel {
	}
	export interface B2BOrderDetailTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
		tiles: TileModel[];
		title: string;
	}
	export interface B2BOrderListTileModel {
		detailUrl: string;
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
		title: string;
	}
	export interface B2BBalanceTileModel {
		contactUsText: HtmlString;
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
		title: string;
	}
	export interface B2BFinanceTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BFavoriteDetailTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		publicShareFavoriteUrl: string;
		tileId: number;
	}
	export interface B2BFavoriteListTileModel {
		detailUrl: string;
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BFavoritePublicSharedTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export interface B2BSiteContextModel extends SiteContextModel {
		footer: B2BFooterViewModel;
		isNewCheckOutEnabled: boolean;
		logoutEndpoint: string;
		resetPasswordSettings: string;
	}
	export interface ModuleConfiguratorUrls {
		baseUrl: string;
		jsBundlePath: string;
	}
	export interface ServerContextModel {
		apiEndPoint: string;
		cdnAssetImages: string;
		cdnAssets: string;
		cdnImageVersionSuffix: string;
		cdnProductImages: string;
		machineName: string;
		moduleConfigurator: ModuleConfiguratorUrls;
		recaptcha: RecaptchaModel;
	}
	export interface SiteContextModel {
		basketPageUrl: string;
		businessContext: BusinessContext;
		country: Country;
		freightInfoModel: FreightInfoModel;
		frontPageUrl: string;
		globalLabels: KeyValuePair<string, KeyValuePair<string, any>[]>[];
		heroBannerSettingsModel: HeroBannerSettingsModel;
		isHaOnlineEnabled: boolean;
		language: string;
		loginLink: LinkModel;
		navigation: NavigationItemModel[];
		productDetailPageLink: LinkModel;
		promotionBanner: PromotionBannerModel;
		searchPageModel: LiveSearchModel;
		siteSettings: KeyValuePair<string, string>[];
	}
	export enum CountryDeliveryType {
		Undefined = 0,
		Wws = 1,
		None = 2,
		Own = 3,
		ShadowCountry = 4
	}
	export interface Country {
		callingCodes: string[];
		code: string;
		deliveryToTargetCountry: boolean;
		deliveryType: CountryDeliveryType;
		doorstepDeliveryMechanisms: DoorstepDeliveryMechanismDefinition[];
		freeDeliveryAmount: number;
		isShadowCountry: boolean;
		localizedNames: KeyValuePair<CultureInfo, string>[];
		name: string;
		postalCodeRegex: string;
		priority: number;
		targetCountryCode: string;
	}
	export interface CountryCode {
		international: string;
		otherCountry: string;
		unspecified: string;
	}
	export enum CalendarAlgorithmType {
		Unknown = 0,
		SolarCalendar = 1,
		LunarCalendar = 2,
		LunisolarCalendar = 3
	}
	export enum CalendarWeekRule {
		FirstDay = 0,
		FirstFullWeek = 1,
		FirstFourDayWeek = 2
	}
	export enum CultureTypes {
		NeutralCultures = 1,
		SpecificCultures = 2,
		InstalledWin32Cultures = 4,
		AllCultures = 7,
		UserCustomCulture = 8,
		ReplacementCultures = 16,
		WindowsOnlyCultures = 32,
		FrameworkCultures = 64
	}
	export enum DigitShapes {
		Context = 0,
		None = 1,
		NativeNational = 2
	}
	export interface Calendar {
		algorithmType: CalendarAlgorithmType;
		eras: number[];
		isReadOnly: boolean;
		maxSupportedDateTime: Date;
		minSupportedDateTime: Date;
		twoDigitYearMax: number;
	}
	export interface CompareInfo {
		lCID: number;
		name: string;
		version: SortVersion;
	}
	export interface CultureInfo {
		calendar: Calendar;
		compareInfo: CompareInfo;
		cultureTypes: CultureTypes;
		currentCulture: CultureInfo;
		currentUICulture: CultureInfo;
		dateTimeFormat: DateTimeFormatInfo;
		defaultThreadCurrentCulture: CultureInfo;
		defaultThreadCurrentUICulture: CultureInfo;
		displayName: string;
		englishName: string;
		ietfLanguageTag: string;
		installedUICulture: CultureInfo;
		invariantCulture: CultureInfo;
		isNeutralCulture: boolean;
		isReadOnly: boolean;
		keyboardLayoutId: number;
		lCID: number;
		name: string;
		nativeName: string;
		numberFormat: NumberFormatInfo;
		optionalCalendars: Calendar[];
		parent: CultureInfo;
		textInfo: TextInfo;
		threeLetterISOLanguageName: string;
		threeLetterWindowsLanguageName: string;
		twoLetterISOLanguageName: string;
		useUserOverride: boolean;
	}
	export interface DateTimeFormatInfo {
		abbreviatedDayNames: string[];
		abbreviatedMonthGenitiveNames: string[];
		abbreviatedMonthNames: string[];
		aMDesignator: string;
		calendar: Calendar;
		calendarWeekRule: CalendarWeekRule;
		currentInfo: DateTimeFormatInfo;
		dateSeparator: string;
		dayNames: string[];
		firstDayOfWeek: DayOfWeek;
		fullDateTimePattern: string;
		invariantInfo: DateTimeFormatInfo;
		isReadOnly: boolean;
		longDatePattern: string;
		longTimePattern: string;
		monthDayPattern: string;
		monthGenitiveNames: string[];
		monthNames: string[];
		nativeCalendarName: string;
		pMDesignator: string;
		rFC1123Pattern: string;
		shortDatePattern: string;
		shortestDayNames: string[];
		shortTimePattern: string;
		sortableDateTimePattern: string;
		timeSeparator: string;
		universalSortableDateTimePattern: string;
		yearMonthPattern: string;
	}
	export interface NumberFormatInfo {
		currencyDecimalDigits: number;
		currencyDecimalSeparator: string;
		currencyGroupSeparator: string;
		currencyGroupSizes: number[];
		currencyNegativePattern: number;
		currencyPositivePattern: number;
		currencySymbol: string;
		currentInfo: NumberFormatInfo;
		digitSubstitution: DigitShapes;
		invariantInfo: NumberFormatInfo;
		isReadOnly: boolean;
		naNSymbol: string;
		nativeDigits: string[];
		negativeInfinitySymbol: string;
		negativeSign: string;
		numberDecimalDigits: number;
		numberDecimalSeparator: string;
		numberGroupSeparator: string;
		numberGroupSizes: number[];
		numberNegativePattern: number;
		percentDecimalDigits: number;
		percentDecimalSeparator: string;
		percentGroupSeparator: string;
		percentGroupSizes: number[];
		percentNegativePattern: number;
		percentPositivePattern: number;
		percentSymbol: string;
		perMilleSymbol: string;
		positiveInfinitySymbol: string;
		positiveSign: string;
	}
	export interface SortVersion {
		fullVersion: number;
		sortId: Guid;
	}
	export interface TextInfo {
		aNSICodePage: number;
		cultureName: string;
		eBCDICCodePage: number;
		isReadOnly: boolean;
		isRightToLeft: boolean;
		lCID: number;
		listSeparator: string;
		macCodePage: number;
		oEMCodePage: number;
	}
	export enum DayOfWeek {
		Sunday = 0,
		Monday = 1,
		Tuesday = 2,
		Wednesday = 3,
		Thursday = 4,
		Friday = 5,
		Saturday = 6
	}
	export enum UriHostNameType {
		Unknown = 0,
		Basic = 1,
		Dns = 2,
		IPv4 = 3,
		IPv6 = 4
	}
	export interface Guid {
		empty: Guid;
	}
	export interface Uri {
		absolutePath: string;
		absoluteUri: string;
		authority: string;
		dnsSafeHost: string;
		fragment: string;
		host: string;
		hostNameType: UriHostNameType;
		idnHost: string;
		isAbsoluteUri: boolean;
		isDefaultPort: boolean;
		isFile: boolean;
		isLoopback: boolean;
		isUnc: boolean;
		localPath: string;
		originalString: string;
		pathAndQuery: string;
		port: number;
		query: string;
		scheme: string;
		schemeDelimiter: string;
		segments: string[];
		uriSchemeFile: string;
		uriSchemeFtp: string;
		uriSchemeGopher: string;
		uriSchemeHttp: string;
		uriSchemeHttps: string;
		uriSchemeMailto: string;
		uriSchemeNetPipe: string;
		uriSchemeNetTcp: string;
		uriSchemeNews: string;
		uriSchemeNntp: string;
		userEscaped: boolean;
		userInfo: string;
	}
	export enum DoorstepDeliveryMechanismType {
		Hook = 0,
		Lift = 1,
		SofaReturn = 2
	}
	export interface DoorstepDeliveryMechanismDefinition {
		all: DoorstepDeliveryMechanismDefinition[];
		sku: Sku;
		type: DoorstepDeliveryMechanismType;
	}
	export interface ProductId {
		customLine: ProductId;
		doorstepDeliveryMechanism: ProductId;
		exactPattern: any;
		familyModelId: string;
		giftCertificate: ProductId;
		invalid: ProductId;
		pickAndPackDelivery: ProductId;
	}
	export interface Sku {
		carrierBag: Sku;
		customLine: Sku;
		doorstepDeliveryMechanismHook: Sku;
		doorstepDeliveryMechanismLift: Sku;
		doorstepDeliveryMechanismSofaReturn: Sku;
		exactPattern: any;
		familyModelId: string;
		giftCertificate: Sku;
		giftPackaging: Sku;
		id: string;
		invalid: Sku;
		pattern: any;
		pickAndPackDelivery: Sku;
		productId: ProductId;
		variantId: VariantId;
	}
	export interface VariantId {
		customLine: VariantId;
		doorstepDeliveryMechanismHook: VariantId;
		doorstepDeliveryMechanismLift: VariantId;
		doorstepDeliveryMechanismSofaReturn: VariantId;
		exactPattern: any;
		giftCertificate: VariantId;
		invalid: VariantId;
		pickAndPackDelivery: VariantId;
	}
	export enum LinkType {
		None = 0,
		ItemWithOnlyLink = 1,
		Content = 3
	}
	export enum NavigationType {
		Left = 1,
		Right = 2,
		MyBolia = 3,
		PartnerInfo = 4
	}
	export interface NavigationItemContentModel {
		id: number;
		isSpaLink: boolean;
		label: NavigationItemLabelModel;
		linkType: LinkType;
		media: MediaModel;
		name: string;
		parentId: number;
		path: string[];
		url: string;
	}
	export interface NavigationItemLabelModel {
		backgroundColor: string;
		text: string;
		textColor: string;
	}
	export interface NavigationItemModel {
		content: NavigationItemContentModel[];
		id: number;
		items: NavigationItemModel[];
		label: NavigationItemLabelModel;
		linkType: LinkType;
		name: string;
		parent: NavigationItemModel;
		parentId: number;
		path: string[];
		spaLink: boolean;
		specialLinks: NavigationItemModel[];
		target: string;
		type: NavigationType;
		url: string;
	}
	export interface PromotionBannerModel {
		backgroundColor: string;
		content: HtmlString[];
		countDownCampaignModel: CampaignViewModel;
	}
	export interface LiveSearchModel {
		quickLinks: QuickLinkModel[];
		searchPageLink: LinkModel;
	}
	export interface QuickLinkModel {
		linkModel: LinkViewModel;
		linkType: number;
		name: string;
		parentId: number;
		pathList: string[];
	}
	export interface FreightInfoModel {
		content: HtmlString;
		title: string;
	}
	export interface HeroBannerBlocksTileModel {
		isScrimEnabled: boolean;
		media: MediaModel;
		tiles: TileModel[];
		type: string;
	}
	export interface HeroBannerImageContainingTextTileModel {
		imageWithCustomText: HeroBannerImageWithCustomTextBlockModel;
		link: LinkViewModel;
		tileId: number;
	}
	export interface HeroBannerSettingsModel {
		disableVideoOnAllDevices: boolean;
		disableVideoOnMobile: boolean;
	}
	export interface HeroBannerSimpleTileModel {
		isScrimEnabled: boolean;
		media: MediaModel;
		title: string;
		type: string;
	}
	export interface HeroBannerTileModel {
		autoPlay: boolean;
		bottomTitle: string;
		bottomTitleSubtext: string;
		campaign: CampaignViewModel;
		disableOverlay: boolean;
		focus: boolean;
		isScrimEnabled: boolean;
		italicBottomTitle: boolean;
		link: LinkViewModel;
		media: MediaModel;
		textHexColor: string;
		title: string;
		topTitle: string;
		type: string;
		useAlternativeFontTopTitle: boolean;
		zoom: boolean;
	}
	export interface IHeroBannerTileModel {
		isScrimEnabled: boolean;
		media: MediaModel;
		type: string;
	}
	export interface RequestSettings<T> {
		data: T;
	}
	export interface B2BResetPasswordSettings {
		hoursBeforeResetPasswordTokenExpires: number;
		resetPasswordUrl: string;
	}
	export interface B2BFooterViewModel {
		columns: FooterColumnModel[];
		copyrightText: string;
		legalCodes: string;
	}
	export interface B2BContentPageContent {
		b2BFooter: B2BFooterViewModel;
		hero: IHeroBannerTileModel;
		tiles: TileModel[];
	}
	export interface B2BContentPageViewModel extends BasePageViewModel {
		basketId: string;
		breadcrumb: BreadcrumbItemModel[];
		content: B2BContentPageContent;
	}
	export enum SiteLayoutType {
		Full = 0,
		Tunnel = 1,
		Checkout = 2
	}
	export interface BasePageViewModel {
		contentType: string;
		hidePromotionBanner: boolean;
		meta: PageMetaData;
		serverContextStateKey: string;
		siteContextStateKey: string;
		siteLayoutType: SiteLayoutType;
	}
	export interface PageMetaData {
		canonical: string;
		hrefLanguages: HrefLanguageModel[];
		metaTags: KeyValuePair<string, string>[];
		openGraphMetaTags: KeyValuePair<string, string>[];
		pageId: number;
		pageType: string;
		title: string;
	}
	export interface HrefLanguageModel {
		culture: string;
		url: string;
	}
	export interface BreadcrumbItemModel {
		name: string;
		spaLink: boolean;
		url: string;
	}
	export interface B2BCheckoutTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		paymentOptions: TileModel[];
		receiptPageLink: LinkModel;
		tileId: number;
	}
	export interface B2BBasketTileModel {
		checkOutUrl: string;
		dictionaryLabels: KeyValuePair<string, any>[];
		emptyBasketTiles: TileModel[];
		tileId: number;
	}
	export interface B2BAgentCustomerOverviewTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
		title: string;
	}
	export enum CollageTileLayoutOption {
		Default = 0,
		Reversed = 1,
		Product = 2,
		HorizontalSlider = 3
	}
	export enum TileLayoutOption {
		FullWidth = 1,
		Layout5050 = 2,
		Layout2575 = 3,
		Layout7525 = 4,
		LookBook = 5,
		SpecialOffer = 6,
		LetsBeFriends = 7,
		HalfWidth = 8,
		Layout3In1 = 9
	}
	export interface ImageFileModel {
		cachebust: number;
		description: string;
		flip?: boolean;
		focus?: boolean;
		focusPoints: string;
		height?: number;
		hexCode: string;
		url: string;
		width?: number;
		zoom?: boolean;
	}
	export interface UspTileItemModel {
		icon: MediaModel;
		link: LinkViewModel;
		title: string;
	}
	export interface UspTileModel {
		backgroundColorHexCode: string;
		items: UspTileItemModel[];
		sliderArrowColorHexCode: string;
		tileId: number;
	}
	export interface SpaRedirectModel {
		link: LinkModel;
	}
	export interface AltaPayPaymentPlaceHolderTileModel {
		formStylingUrl: string;
		gatewayBaseUrl: string;
		shopName: string;
		tileId: number;
	}
	export interface B2BBankTransferPaymentTileModel {
		tileId: number;
	}
	export interface GiftCardPaymentTileModel {
		tileId: number;
	}
	export interface HeroBannerImageWithCustomTextBlockModel {
		altText: string;
		image: MediaModel;
	}
	export interface RecaptchaModel {
		siteKey: string;
	}
	export interface TileTileModel {
		autoPlay: boolean;
		enableScrim: boolean;
		focus: boolean;
		media: MediaModel;
		mediaText: string;
		mediaTitle: string;
		placeTextOnImage: boolean;
		primaryLink: LinkViewModel;
		subheading: string;
		text: HtmlString;
		textColor: string;
		tileId: number;
		title: string;
	}
	export interface TileContentModel {
		isScrimEnabled: boolean;
		link: LinkViewModel;
		media: MediaModel;
		subheading: string;
		text: string;
		tileId: number;
		title: string;
		vote: VoteModel;
	}
	export interface TextTileModel {
		link: LinkViewModel;
		readMoreText: boolean;
		seoText: boolean;
		seoTexts: HtmlString[];
		subheading: string;
		text: HtmlString;
		tileId: number;
		title: string;
	}
	export interface HighlightTileModel {
		autoPlay: boolean;
		focus: boolean;
		link: LinkViewModel;
		media: MediaModel;
		subheading: string;
		text: HtmlString;
		tileId: number;
		title: string;
		zoom: boolean;
	}
	export interface HtmlString {
	}
	export interface CollageTileModel {
		disableVideoOnMobile: boolean;
		layout: CollageTileLayoutOption;
		mirrorLayoutOnFirstSlide: boolean;
		subheading: string;
		text: string;
		textColor: string;
		tileId: number;
		tiles: TileModel[];
		title: string;
	}
	export interface QuestionAndAnswerModel {
		text: HtmlString;
		tileId: number;
		title: string;
	}
	export interface QuestionsAndAnswersTileModel {
		autoPlay: boolean;
		focus: boolean;
		hideImageOnMobile: boolean;
		media: MediaModel;
		questionAndAnswers: TileModel[];
		text: HtmlString;
		tileId: number;
		title: string;
		zoom: boolean;
	}
	export interface GridContainerModel {
		tileId: number;
		tiles: TileModel[];
	}
	export interface GiftPackagingTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		tileId: number;
	}
	export enum CatalogTileLayoutOption {
		Landscape = 1,
		LandscapeAndMirror = 2,
		Portrait = 3,
		PortraitAndMirror = 4
	}
	export interface CatalogTileModel {
		backgroundColor: string;
		layout: CatalogTileLayoutOption;
		link: LinkViewModel;
		primaryMedia: MediaModel;
		secondaryMedia: MediaModel;
		subheading: string;
		text: HtmlString;
		tileId: number;
		title: string;
		useAlternativeStylingForSubheading: boolean;
	}
	export interface TrustpilotWidgetTileModel {
		backgroundColorHexCode: string;
		tileId: number;
		trustpilotBusinessUnitId: string;
	}
	export interface CallToActionTileModel {
		alternativeLinkStyle: boolean;
		backgroundColor: string;
		disableVideoOnMobile: boolean;
		flipImageAndText: boolean;
		layout: TileLayoutOption;
		positionLinkAtBottomOfImage: boolean;
		textColor: string;
		tileId: number;
		tiles: TileModel[];
		title: string;
		useCarouselOnMobile: boolean;
	}
	export interface ClaimFormTileModel {
		dictionaryLabels: KeyValuePair<string, any>[];
		freightIssueOptions: ClaimFormIssueOption[];
		freightPictureGuideDescriptions: ClaimFormPictureGuideDescription[];
		issueOptions: ClaimFormIssueOption[];
		pictureGuideDescriptions: ClaimFormPictureGuideDescription[];
		queue: string;
		tileId: number;
	}
	export interface ClaimFormIssueOption {
		code: string;
		displayName: string;
	}
	export interface ClaimFormPictureGuideDescription {
		description: HtmlString;
		image1: string;
		image2: string;
		title: string;
	}
	export enum BusinessContext {
		B2C = 0,
		B2B = 1,
		Store = 2
	}

